import Joyride from "react-joyride";
import { steps_tour_guide_chat_bot } from "./steps_chatbot";
import { TooltipComponent } from "./ContentGuide";
import useChatbot from "../../hooks/chatbot/useChatbot";
import { joyrideStylesOptions } from "./guide.style";

const TutorialGuide = () => {
    const { ref, state, handlers } = useChatbot();

    return (
        <Joyride
            ref={ref.joyrideRef}
            callback={handlers.handleJoyrideCallback}
            run={state.run}
            continuous
            steps={steps_tour_guide_chat_bot}
            tooltipComponent={TooltipComponent}
            disableOverlayClose={true}
            showSkipButton
            styles={joyrideStylesOptions}
        />
    );
};

export default TutorialGuide;
